<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kEFVzW/tc-custom/9781555849191.jpg?1697123093238" alt="This image is the cover for the book Book of Clouds"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Book of Clouds
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A young Mexican woman adrift in post-unification Berlin encounters romance, violence, and revelation in this “stirring and lyrical first novel” (Paul Auster, award-winning author and filmmaker).</b></p><p>Having escaped her overbearing family in Mexico, Tatiana settles in the newly reunified city of Berlin, where she hopes to cultivate a life of solitude. But when she takes a job transcribing notes for the reclusive historian, <i>Doktor</i> Weiss, Tatiana’s simple life becomes more complex—and more perilous. Through Weiss, she meets a young meteorologist who, as a child in East Germany, took solace in the sky’s constant shape-shifting, an antidote to his grim and unchanging reality. As their three conflicting worlds begin to merge, the tension culminates in an act of violence that will leave none of them untouched.</p><p>Unfolding with the logic of a dream, <i>Book of Clouds</i> is both “a stunningly accurate portrait of Berlin” and a beautiful exploration of the myths we cling to in order to give our lives meaning. From a crowded U-Bahn where Hitler appears dressed as an old woman to an underground Gestapo bowling alley whose walls bear score marks from games long settled, Chloe Aridjis guides us through layers of history with wit and compassion, blurring the lines between real and imagined. Her debut novel is “required reading of the most pleasurable sort” (<i>The New York Times</i>).</p><b>Named one of the 10 Best Books Set in Berlin by <i>The Guardian</i>.</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Chloe Aridjis
      </h2>
      
      <p class="authorDescription body article">Chloe Aridjis was born in New York and grew up in the Netherlands and Mexico. She received her PhD in nineteenth-century French poetry and magic shows from Oxford, then lived in Berlin for five years. Her first novel, <I>Book of Clouds</I>, won the Prix du Premier Roman Etranger in 2009. Aridjis lives in London.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Black Cat
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5a8ed612